<template>
  <div v-if="amReady">
    <div class="p-3">
      <div class="mb-4 ">
        <div class="title text-uppercase text-left  d-inline-block" v-if="formHeader">{{ this.getFormTitle }}</div>

        <dg-button :click="createModule" :icon="actionButtonIcon" :loading="requestOn" :text="actionButtonLabel" class="float-right d-inline-block"
                   :translate="false" :type="actionButtonType" fieldSize="mini"
                   v-if="editable"></dg-button>
      </div>

      <div class="border-top pt-3">
        <el-row>
          <el-col :class="$langConfig.cssClass" :span="(!editMode)? 5 : 5">
            <dg-text-field
                :control="control"
                :editable="editable"
                :field_span="22"
            :label_span="22"
                :translateLabel='false'
                field_mark="required"
                label="Title"
                name="title"
                placeholder="CC China"
                rules="required">
            </dg-text-field>
          </el-col>

          <el-col :class="$langConfig.cssClass" :span="(!editMode)? 4 : 4">
            <dg-select-field
                :control="control"
                :field_span="22"
                :label_span="22"
                :options="$store.state['voip-rate-division-api'].dropDownList"
                :translateLabel="false"
                :translateLabels="false"
                field_mark="required"
                label="Division"
                name="division_id"
                rules="required"></dg-select-field>
          </el-col>

          <el-col :class="$langConfig.cssClass" :span="(!editMode)? 4 : 4">
            <dg-text-field
                :control="control"
                :editable="editable"
                :field_span="22"
            :label_span="22"
                :translateLabel='false'
                field_mark="required"
                label="Caller ID"
                name="caller_id"
                placeholder="11284825829"
                rules="required"></dg-text-field>
          </el-col>

          <el-col :class="$langConfig.cssClass" :span="(!editMode)? 4 : 4">
            <dg-number-field
                :control="control"
                :defaultValue="1"
                :editable="editable"
                :field_span="22"
                :label_span="22"
                :max="20"
                :min="1"
                :translateLabel='false'
                field_mark="required"
                label="Numbers to Generate"
                name="phone_numbers_to_generate"
                rules="required"></dg-number-field>
          </el-col>

          <el-col :class="$langConfig.cssClass" :span="(!editMode)? 4 : 4">
            <dg-radio-field
                :control="control"
                :defaultValue="1"
                :field_span="22"
                :label_span="22"
                :options="radioOptions"
                :translateLabel="false"
                :translateLabels="false"
                field_mark="required"
                label="Start Directly"
                name="start_after_creation"
                rules="required"></dg-radio-field>
          </el-col>
        </el-row>
        <el-row>
          <el-col :class="$langConfig.cssClass" :span="(!editMode)? 5 : 5">
            <dg-text-field
                :control="control"
                :editable="editable"
                :field_span="22"
            :label_span="22"
                :defaultValue="lastUsedDialingDelay"
                :translateLabel='false'
                field_mark="required"
                label="Calls Interval"
                name="delay_between_calls_in_ms"
                placeholder="1"
                rules="required">
              <!--<template slot="field_note">
                <i class="ml-2" style="font-size: 10pt;">1 000 000 (1 million) => 1 second</i>
              </template>-->
            </dg-text-field>
          </el-col>

          <el-col :class="$langConfig.cssClass" :span="(!editMode)? 4 : 4">
            <dg-select-field
                :control="control"
                :field_span="22"
                :label_span="22"
                :multiple="true"
                :options="$store.state['voip-destination-api'].dropDownList"
                :translateLabel="false"
                :translateLabels="false"
                @amUpdated="destinationUpdated"
                class="mt-0 mb-0"
                :field_mark="(actions_do_not_affect_system)? 'required' : 'optional'"
                htmlautocomplete="new-password"
                label="Destination"
                labelProperty="label"
                name="destination_id"
                placeholder="Canada / ATI"
                :rules="(actions_do_not_affect_system)? 'required' : 'optional'"
                valueProperty="value"
            ></dg-select-field>
          </el-col>


          <!-- <el-col :class="$langConfig.cssClass" :span="(!editMode)? 6 : 6" v-if="!actions_do_not_affect_system"> -->
          <el-col :class="$langConfig.cssClass" :span="(!editMode)? 6 : 6">
            <dg-radio-field
                :control="control"
                :defaultValue="1"
                :field_span="22"
            :label_span="22"
                :options="radioOptions"
                :translateLabel="false"
                :translateLabels="false"
                field_mark="required"
                label="Use Top Destinations"
                name="using_only_top_destinations"
                rules="required"></dg-radio-field>
          </el-col>
        </el-row>

        <el-row>
          <el-col :class="$langConfig.cssClass" :span="(!editMode)? 12 : 12">
            <dg-radio-field
                :control="control"
                defaultValue="0"
                :field_span="22"
            :label_span="22"
                :options="radioOptions"
                :translateLabel="false"
                :translateLabels="false"
                field_mark="required"
                label="Monitor Taking Actions"
                name="monitor_mode_for_tacking_actions"
                rules="required">
              <template slot="field_note">
                <div style="text-justify: auto;text-align: justify-all;white-space: nowrap;">
                  <i class="ml-2" style="font-size: 10pt;">if enabled, <b>Taking Actions Process</b> will show every single action individually in the view log dialog for 4 seconds before moving to the next one.</i>
                </div>
              </template>
            </dg-radio-field>
          </el-col>

          <!--<el-col :class="$langConfig.cssClass" :span="(!editMode)? 6 : 6">
            <dg-radio-field
                :control="control"
                :defaultValue="1"
                :field_span="22"
            :label_span="22"
                :options="radioOptions"
                :translateLabel="false"
                :translateLabels="false"
                field_mark="required"
                label="Monitor Calls Making"
                name="monitor_mode_for_making_calls"
                rules="required"></dg-radio-field>
          </el-col>-->
        </el-row>

        <el-row>
          <el-col :span="24" class="mt-2">
            <el-col :class="$langConfig.cssClass" :span="12" class="mt-4">
              <label class="error-field-validate-message text-capitalize"
                     v-show="!this.validData">{{
                  (requestErrorMessage) ? $ml.get(requestErrorMessage) : $ml.get('fields_do_not_match_the_required_criteria')
                }}</label>
            </el-col>
            <el-col :span="12" class="pt-3 text-right">
              <dg-confirm-button
                  :loading="requestOn"
                  :onConfirm="moduleDeleteAction"
                  :translate="false"
                  class="mr-2"
                  confirmButtonType="danger"
                  fieldSize="mini"
                  icon="el-icon-delete"
                  popIcon="el-icon-delete"
                  text="remove"
                  title="sure to removing this record ?"
                  type="danger"
                  v-if="editMode"></dg-confirm-button>

              <dg-button :click="cancelEditable" class="mr-2" fieldSize="mini" icon="el-icon-close" text="cancel"
                         type="warning" v-if="editable && editMode"></dg-button>
              <dg-button :click="changeEditable" fieldSize="mini" icon="el-icon-edit" text="edit" type="success"
                         v-if="!editable && editMode"></dg-button>



              <!--<dg-confirm-button
                  :icon="actionButtonIcon"
                  :loading="requestOn"
                  :onConfirm="createModule"
                  :text="actionButtonLabel"
                  :translate="false"
                  :type="actionButtonType"
                  fieldSize="mini"
                  v-if="editable"></dg-confirm-button>-->
            </el-col>
          </el-col>
        </el-row>
      </div>

    </div>
    <!--<div class="app-board mt-2 w-100">
      <div class="automated-test-log">Automation Test Log</div>

      <el-row :key="pKey" class="mb-2 w-100" v-for="(pKey, pVal) in automationTestLog">
        <el-col :md="6" :lg="4" :sm="6">
          <span v-html="pVal" class="text-uppercase log-title"></span>
        </el-col>
        <el-col :md="18" :lg="20" :sm="18">
          <span class="app-bg-gold-low-alfa p-2" v-html="pKey" style="display: inline-block;width: calc(100% - 350px);word-break: break-all;"></span>
        </el-col>
      </el-row>

      <dg-confirm-button
          :loading="requestOn"
          :onConfirm="stopCurrentTestAction"
          :translate="false"
          fieldSize="mini"
          icon="el-icon-remove-outline"
          text="Stop Test "
          type="danger"
          v-if="abilityToMakeNewTestState == 0"></dg-confirm-button>

      <dg-confirm-button
          :loading="requestOn"
          :onConfirm="takeActionsAction"
          :translate="false"
          fieldSize="mini"
          icon="el-icon-info"
          text="Take Actions"
          type="primary"
          v-if="abilityToMakeNewTestState == 1"></dg-confirm-button>
    </div>-->
  </div>
</template>

<script>

import module from './../index.js'

import {notify, notifySuccess, notifyDanger} from '@/system-services/notify.js'

import fieldController from 'devegram-vue-data-collecter-eui/src/mixins/fieldController';
import moduleForm from '@/modules-config/mixins/moduleForm.js';
import moduleFormProps from '@/modules-config/mixins/moduleFormProps.js';

export default {
  beforeMount() {
    this.getFormData()
  },
  props: {
    actions_do_not_affect_system: {
      default: false,
    }
  },
  data() {
    return {
      lastUsedDialingDelay: 10,
      currentRunningTestId: null,
      automationTestLog: [],
      abilityToMakeNewTest: {},
      isTestTakingActions: 0,
      module: {...module},
      control: this,
      amReady: false,
      requestOn: false,
      editable: !this.editMode,
      requestErrorMessage: null,
      radioOptions: [
        {
          label: 'Yes',
          value: 1,
          link_label: ''
        },
        {
          label: 'No',
          value: '0',
          link_label: ''
        }
      ],
      intervalHandler: null,
      intervalHandlerTakingAction: null
    }
  },
  methods: {
    destinationUpdated (inputField) {
      let val = inputField.field.field_value
    },
    ...$mapActions('voip-rate-division-api', {getDivisionsDropDownList: 'getDropDownList'}),
    ...$mapActions('voip-test-automation-api', {getEntityDropDownList: 'getDropDownList'}),
    ...$mapActions('voip-destination-api', {getDestinationsDropDownList: 'getDropDownList'}),
    IsJsonString(str) {
      try {
        JSON.parse(str)
      } catch (e) {
        return false;
      }
      return true;
    },
    getFormData() {
      let promises = []

      promises.push(this.getEntityDropDownList().then())
      promises.push(this.getDivisionsDropDownList().then(r => {}))
      promises.push(this.getDestinationsDropDownList().then(r => {}))
      Promise.all(promises).then((values) => {
        this.amReady = true
        $vue.nextTick(() => {
          this.bindController()
        })
      })
    },

    async createModule() {
      this.validateFields().then(async result => {
        if (!result) {
          this.requestErrorMessage = null;
          return
        }

        //this.requestOn = true
        let context = this;
        let apiMethod = (this.editMode) ? 'update' : 'create';
        this.dataModel.actions_do_not_affect_system = this.actions_do_not_affect_system
        let apiParams = {data: {...this.dataModel}};
        if (this.editMode) apiParams.id = this.dataToBind.id;

        this.$store.dispatch('voip-test-automation-api/' + apiMethod, apiParams).then(response => {
          this.amReady = false
          notifySuccess((apiMethod == 'update') ? 'Created' : 'Created')

          $vue.nextTick(() => {
            context.amReady = true
            if (context.editMode) {
              if (context.onEditCallback) context.onEditCallback(response.data)
            } else {
              if (context.onCreateCallback) context.onCreateCallback(response.data)
            }
          })

        }).catch(error => {
          let context = this;
          let responseData = error.response.data.message
          if(this.IsJsonString(responseData)) {
            let data = JSON.parse(responseData)
            let status = data.status


            if (status == 200) {
              this.amReady = false
              $vue.nextTick(() => {
                context.amReady = true
                if (context.editMode) {
                  if (context.onEditCallback) context.onEditCallback(data.data)
                } else {
                  if (context.onCreateCallback) context.onCreateCallback(data.data)
                }
              })

              notify({
                type: 'success',
                title: 'Created',
              });
            } else {
              notify({
                type: 'error',
                title: 'Failed',
              });
            }
          } else {
            notify({
              type: 'error',
              title: 'Failed',
            });
            console.log('catch error', error)
          }
          /*
          this.validData = false
          if (error.response.data.errorMessage) {
            this.requestErrorMessage = error.response.data.errorMessage
          } else {
            this.setfieldsErrorMessage({
              fieldsErrors: error.response.data
            });
          }*/
        }).finally(() => {
          this.requestOn = false
        })
      })
    }
  },
  mixins: [fieldController, moduleForm, moduleFormProps],
}
</script>

<style scoped>
  .automated-test-log {
    font-size: 11pt;
    border-bottom: 1px solid #ccc;
    padding: 5px 0;
    margin-bottom: 5px;;
  }
</style>
